import { AnalysisVirtualizedStepProps } from "@models/platform-analysis/entities/analysis";
import { AnalysisVirtualizedTable } from "@pages/platform-analysis-v2/_id/components/virtualized-table";
import { memo } from "react";

interface FeeAnalysisTableProps {
  tableRenderConfig: AnalysisVirtualizedStepProps;
  tableTitle: string;
}
export const FeeAnalysisTable = memo(
  ({ tableRenderConfig, tableTitle }: FeeAnalysisTableProps) => {
    return (
      <AnalysisVirtualizedTable
        stepNumber={4}
        virtualizedProps={{
          ...tableRenderConfig,
          tableTitle: tableTitle,
        }}
      />
    );
  },
);
